import i18n from '@/lib/i18n';

export default {
  INIT_ENV(state) {
    const { host } = window.location;
    if (/lreview\d*\.cre\.ma/.test(host)) state.env = 'development';
    else if (/[adst]review\d*\.cre\.ma/.test(host)) state.env = 'staging';
    else if (/review\d*\.cre\.ma/.test(host)) state.env = 'production';
    else state.env = 'invalid';
  },
  SET_TITLE(state, title) {
    const newTitle = title + i18n.t('app.default_title');
    state.title = newTitle;
    document.title = newTitle;
  },
  SET_PREVIEW(state, preview) {
    state.preview = preview;
  },
  SET_BRAND_CODE(state, brand_code) {
    state.brandCode = brand_code;
  },
  SET_PRODUCT_CODE(state, product_code) {
    state.productCode = product_code;
  },
  SET_CATEGORY_CODE(state, category_code) {
    state.categoryCode = category_code;
  },
  SET_API(state, api) {
    state.api = api;
  },
  SET_CATEGORY_ID(state, categoryId) {
    state.categoryId = categoryId;
  },
  SET_SCORES(state, scores) {
    state.scores = scores;
  },
  SET_SORT(state, sort) {
    state.sort = sort;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
  SET_REVIEW_OPTIONS(state, reviewOptions) {
    state.reviewOptions = reviewOptions;
  },
  SET_PRODUCT_OPTIONS(state, productOptions) {
    state.productOptions = productOptions;
  },
  SET_UNLINKABLE(state, unlinkable) {
    state.unlinkable = unlinkable;
  },
  SET_WITH_VIDEO(state, withVideo) {
    state.withVideo = withVideo;
  },
  SET_COHORT_ITEM_ID(state, cohortItemId) {
    state.cohortItemId = cohortItemId;
  },
  SET_EXPIRES_SINCE(state, expiresSince) {
    state.expiresSince = expiresSince;
  },
  SET_EXPIRES_UNTIL(state, expiresUntil) {
    state.expiresUntil = expiresUntil;
  },
  SET_WIDGET_ENV(state, widgetEnv) {
    state.widgetEnv = widgetEnv;
  },
  SET_PARENT_WIDGET_TYPE(state, parentWidgetType) {
    state.parentWidgetType = parentWidgetType;
  }
};
